// Automatically generated from TW.Saga.Core.Base, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @15.06.2017 16:59:23
import { ListDeviceType_abstract } from './../abstract/SagaBase/ListDeviceType_abstract';
export class ListDeviceType extends ListDeviceType_abstract {}
